export default __webpack_public_path__ + "static/media/Strong Customer Authentication (1).2eb33829.svg";